import { fabric } from "fabric";
import {PreviewHelper} from "@/preview/PreviewHelper";

const getTextLayerBase64 = (element) => {
  const dataURL = element.toDataURL();
  return dataURL.split(';base64,').pop();
}

export const getPreviewTextLayerImages = (jsonSave, originalSpec, textColor) => {
  const textLayerImages = drawSplitCanvas(jsonSave, originalSpec, textColor, nse_config.image_settings.dpi_preview_image);
  return textLayerImages;
};

export const getFinalTextLayerImages = (jsonSave, originalSpec, textColor) => {
    let dpi = nse_config.image_settings.dpi_print_image
    if (jsonSave.product_finish === 'download'){
        dpi = nse_config.image_settings.dpi_download_image
    }
    const textLayerImages = drawSplitCanvas(jsonSave, originalSpec, textColor, dpi);
    return textLayerImages;
}

export const drawCanvas = (jsonSaveEditor, originalSpec, textColor, dpi) => {
    const resolution = getPosterResolution(
      originalSpec.poster_height,
      originalSpec.poster_width,
      dpi
    );
    // console.log(jsonSave);
    // console.log(originalSpec);
    // console.log(resolution);
  
    const element = document.createElement("canvas");
    const canvas = new fabric.Canvas(element, {
      enableRetinaScaling: false,
      height: resolution.height,
      width: resolution.width,
    });

    const jsonSave = prepareText(jsonSaveEditor)

    const textSaying = getTextSaying(jsonSave, originalSpec, textColor, resolution);
    const textDetails = getTextDetails(jsonSave, originalSpec, textColor, resolution);
    const textCity = getTextCity(jsonSave, originalSpec, textColor, resolution);
    const textCountry = getTextCountry(jsonSave, originalSpec, textColor, resolution);

    textSaying && (canvas.add(textSaying));
    textCity && (canvas.add(textCity));
    textCountry && (canvas.add(textCountry));

    canvas.add(textDetails);
    canvas.renderAll();
  
    return element;
};

const getTextSaying = (jsonSave, originalSpec, textColor, resolution, isSplit = false) => {
  if (!jsonSave.text_messages) return null
  const textSaying = new fabric.Text(jsonSave.text_messages, {
    fontSize: originalSpec.text_saying.font_size_modifier * (resolution.height / 100),
    fontWeight: originalSpec.text_saying.font_weight,
    lineHeight: ( originalSpec.text_saying.line_height_modifier * ( resolution.height / 100 )) / ( originalSpec.text_saying.font_size_modifier * ( resolution.height / 100 )) / 1.13,
    fill: textColor,
    fontFamily: jsonSave.message_font,
    textAlign: originalSpec.text_saying.text_align,
  });

  if (!isSplit) {
    textSaying.originX = originalSpec.text_saying.text_align,
    textSaying.originY = originalSpec.text_saying.vertical_align
    textSaying.left = getTextLeft(textSaying.width, resolution.width, originalSpec.text_saying.x_modifier, originalSpec.text_saying.text_align)
    textSaying.top = getTextTop(textSaying.height, resolution.height, jsonSave.text_messages, originalSpec.text_saying.y_modifier, originalSpec.text_saying.max_text_lines, originalSpec.text_saying.vertical_align, originalSpec.text_saying.line_height_modifier)
  }

  // textSaying.left = (resolution.width - textSaying.width) / 2
  return textSaying
}

const getTextCity = (jsonSave, originalSpec, textColor, resolution, isSplit = false) => {
  if (!jsonSave.text_city) return null
  const textCity = new fabric.Text(jsonSave.text_city, {
    fontSize: originalSpec.text_city.font_size_modifier * (resolution.height / 100),
    fontWeight: originalSpec.text_city.font_weight,
    lineHeight: ( originalSpec.text_city.line_height_modifier * ( resolution.height / 100 )) / ( originalSpec.text_city.font_size_modifier * ( resolution.height / 100 )) / 1.13,
    fill: textColor,
    fontFamily: jsonSave.message_font,
    textAlign: originalSpec.text_city.text_align,
    
  });

  if (!isSplit) {
    textCity.originX = originalSpec.text_city.text_align,
    textCity.originY = originalSpec.text_city.vertical_align
    textCity.left = getTextLeft(textCity.width, resolution.width, originalSpec.text_city.x_modifier, originalSpec.text_city.text_align)
    textCity.top = getTextTop(textCity.height, resolution.height, jsonSave.text_city, originalSpec.text_city.y_modifier, originalSpec.text_city.max_text_lines, originalSpec.text_city.vertical_align, originalSpec.text_city.line_height_modifier)
  }
  
  // textCity.left = (resolution.width - textCity.width) / 2
  return textCity
}

const getTextCountry = (jsonSave, originalSpec, textColor, resolution, isSplit = false) => {
  if (!jsonSave.text_country) return null
  const textCountry = new fabric.Text(jsonSave.text_country, {
    fontSize: originalSpec.text_country.font_size_modifier * (resolution.height / 100),
    fontWeight: originalSpec.text_country.font_weight,
    lineHeight: ( originalSpec.text_country.line_height_modifier * ( resolution.height / 100 )) / ( originalSpec.text_country.font_size_modifier * ( resolution.height / 100 )) / 1.13,
    fill: textColor,
    fontFamily: jsonSave.message_font,
    textAlign: originalSpec.text_country.text_align,
  });

  if (!isSplit) {
    textCountry.originX = originalSpec.text_country.text_align,
    textCountry.originY = originalSpec.text_country.vertical_align
    textCountry.left = getTextLeft(textCountry.width, resolution.width, originalSpec.text_country.x_modifier, originalSpec.text_country.text_align)
    textCountry.top = getTextTop(textCountry.height, resolution.height, jsonSave.text_country, originalSpec.text_country.y_modifier, originalSpec.text_country.max_text_lines, originalSpec.text_country.vertical_align, originalSpec.text_country.line_height_modifier)
  }
  
  // textCity.left = (resolution.width - textCity.width) / 2
  return textCountry
}

const getTextLocationAndCoord = (jsonSave) => {
  var t = jsonSave.text_location;
  if (jsonSave.text_location && jsonSave.text_coordinates_title) {
      t += ' - '
  }
  t += jsonSave.text_coordinates_title
  return t
}

const getTextDetails = (jsonSave, originalSpec, textColor, resolution, isSplit = false) => {
  let text = []

  if (jsonSave.poster_style === 'explorer' || jsonSave.poster_style === 'photographer') {
    text = [
      getTextLocationAndCoord(jsonSave),
      jsonSave.text_date,
    ]
  } else {
    text = [
      jsonSave.text_coordinates_title,
      jsonSave.text_location,
      jsonSave.text_date,
      jsonSave.text_title
    ]
  }

  text = text.filter(Boolean).reverse().join("\n")

  const textDetails = new fabric.Text(text, {
    fontSize: originalSpec.text_details.font_size_modifier * (resolution.height / 100),
    fontWeight: originalSpec.text_details.font_weight,
    lineHeight: ( originalSpec.text_details.line_height_modifier * ( resolution.height / 100 )) / ( originalSpec.text_details.font_size_modifier * ( resolution.height / 100 )) / 1.13,
    fill: textColor,
    fontFamily: jsonSave.detail_font,
    textAlign: originalSpec.text_details.text_align,
    
  });

  if (!isSplit) {
    textDetails.originX = originalSpec.text_details.text_align,
    textDetails.originY = originalSpec.text_details.vertical_align
    textDetails.left = getTextLeft(textDetails.width, resolution.width, originalSpec.text_details.x_modifier, originalSpec.text_details.text_align)
    textDetails.top = getTextTop(textDetails.height, resolution.height, text, originalSpec.text_details.y_modifier, originalSpec.text_details.max_text_lines, originalSpec.text_details.vertical_align, originalSpec.text_details.line_height_modifier)
  }
 
  // textDetails.left = (resolution.width - textDetails.width) / 2
  return textDetails
}

const getPosterResolution = (heightCm, widthCm, dpi) => {
  return {
    dpi,
    height: Math.round((dpi * heightCm * 10) / 25.4),
    width: Math.round((dpi * widthCm * 10) / 25.4),
  };
};

const getTextLeft = (text_width, canvas_width, x_modifier, allignment) => {  
  switch (allignment) {
    case "left":
      // we need code here for street map styles
      // break;
    case "right":
      /// we need code here for street map styles
      // break;
    case "justify":
      // we dont use justify as of now
      // break;
    case "center":
      return canvas_width * (x_modifier / 100);
      default:
    // error
  }
}

const getTextTop = (text_height, canvas_height, text_messages, y_modifier, max_text_lines, allignment, lineHeight) => {
  var text_lines = text_messages.split( "\n" ).length;
  switch (allignment) {
    case "top":
      // we need code here for street map styles
      // break;
    case "bottom":
      // break;
      /// we need code here for street map styles
    case "center":
      // Calculating the text center based on the max lines. This is the true vertical center of the text box (deviation is 4-10px from the approach below)
      //return ( canvas_height * ( y_modifier / 100 )) + ( text_height * ( max_text_lines / text_lines ) / 2 );
      // In Futurify > Night Sky > night-sky-editors-plugin > ParseSpecifications.js: 
      // We calculate the text box height based on the line height * max lines. We have to mirror the FE preview approch here to have the text alligned the same way on the image.
      return ( canvas_height * ( y_modifier / 100 )) + ((lineHeight * (canvas_height / 100)) * max_text_lines / 2 );
    default:
      // error
  }
}

export const getTextColor = (selectedOptions) => {
  const posterStyle = selectedOptions.poster_style.value
  const { textColor, starMapColor } = PreviewHelper({selectedItems: selectedOptions})

  if (posterStyle === 'aquarelles') {
    return '#000000';
  } else if (posterStyle === 'explorer') {
    return '#ffffff';
  } else if (posterStyle === 'photographer') {
    return starMapColor.value
  } 
  
  return textColor.value
}

const getCanvasWidth = (element, resolution) => {
  const extraWidth = element.fontSize * 2
  const elementWidth = element.getBoundingRect().width

  let width = elementWidth + extraWidth

  if (elementWidth + extraWidth > resolution.width) width = resolution.width

  return { width, extraWidth }
}

const getCanvasHeight = (element, resolution) => {
  const extraHeight = element.fontSize * 2
  const elementHeight = element.getBoundingRect().height

  let height = elementHeight + extraHeight

  if (elementHeight + extraHeight > resolution.height) height = resolution.height

  return { height, extraHeight }
}

export const drawSplitCanvas = (jsonSaveEditor, originalSpec, textColor, dpi) => {
  const resolution = getPosterResolution(
    originalSpec.poster_height,
    originalSpec.poster_width,
    dpi
  );

  const jsonSave = prepareText(jsonSaveEditor)

  const textSaying = getTextSaying(jsonSave, originalSpec, textColor, resolution, true);
  const textDetails = getTextDetails(jsonSave, originalSpec, textColor, resolution, true);
  const textCity = getTextCity(jsonSave, originalSpec, textColor, resolution, true);
  const textCountry = getTextCountry(jsonSave, originalSpec, textColor, resolution, true);

  const textLayerSplit = []
 
  if (textSaying){
    const elementSaying = document.createElement("canvas");
    const canvasWidth = getCanvasWidth(textSaying, resolution).width
    const canvasHeight = getCanvasHeight(textSaying, resolution).height
    const canvasSaying = new fabric.Canvas(elementSaying, {
      enableRetinaScaling: false,
      width: canvasWidth,
      height: canvasHeight
    })

    canvasSaying.add(textSaying)
    canvasSaying.centerObject(textSaying)
    canvasSaying.renderAll()

    textLayerSplit.push({
      base64: getTextLayerBase64(elementSaying),
      x: getTextLeft(textSaying.width, resolution.width, originalSpec.text_saying.x_modifier, originalSpec.text_saying.text_align) - (canvasWidth / 2),
      y: getTextTop(textSaying.height, resolution.height, jsonSave.text_messages, originalSpec.text_saying.y_modifier, originalSpec.text_saying.max_text_lines, originalSpec.text_saying.vertical_align, originalSpec.text_saying.line_height_modifier) - (canvasHeight / 2)
    })
  }

  if (textCity){
    const elementCity = document.createElement("canvas");
    const canvasWidth = getCanvasWidth(textCity, resolution).width
    const canvasHeight = getCanvasHeight(textCity, resolution).height
    const canvasCity = new fabric.Canvas(elementCity, {
      enableRetinaScaling: false,
      width: canvasWidth,
      height: canvasHeight
    })

    canvasCity.add(textCity)
    canvasCity.centerObject(textCity)
    canvasCity.renderAll()

    textLayerSplit.push({
      base64: getTextLayerBase64(elementCity),
      x: getTextLeft(textCity.width, resolution.width, originalSpec.text_city.x_modifier, originalSpec.text_city.text_align) - (canvasWidth / 2),
      y: getTextTop(textCity.height, resolution.height, jsonSave.text_city, originalSpec.text_city.y_modifier, originalSpec.text_city.max_text_lines, originalSpec.text_city.vertical_align, originalSpec.text_city.line_height_modifier) - (canvasHeight / 2)
    })
  }

  if (textCountry){
    const elementCountry = document.createElement("canvas");
    const canvasWidth = getCanvasWidth(textCountry, resolution).width
    const canvasHeight = getCanvasHeight(textCountry, resolution).height
    const canvasCountry = new fabric.Canvas(elementCountry, {
      enableRetinaScaling: false,
      width: canvasWidth,
      height: canvasHeight
    })

    canvasCountry.add(textCountry)
    canvasCountry.centerObject(textCountry)
    canvasCountry.renderAll()

    textLayerSplit.push({
      base64: getTextLayerBase64(elementCountry),
      x: getTextLeft(textCountry.width, resolution.width, originalSpec.text_country.x_modifier, originalSpec.text_country.text_align) - (canvasWidth / 2),
      y: getTextTop(textCountry.height, resolution.height, jsonSave.text_country, originalSpec.text_country.y_modifier, originalSpec.text_country.max_text_lines, originalSpec.text_country.vertical_align, originalSpec.text_country.line_height_modifier) - (canvasHeight / 2)
    })
  }

  if (textDetails){
    const elementDetails = document.createElement("canvas");
    const canvasWidth = getCanvasWidth(textDetails, resolution).width
    const canvasHeight = getCanvasHeight(textDetails, resolution).height
    const canvasDetails = new fabric.Canvas(elementDetails, {
      enableRetinaScaling: false,
      width: canvasWidth,
      height: canvasHeight
    })

    let text = []

    if (jsonSave.poster_style === 'explorer' || jsonSave.poster_style === 'photographer') {
      text = [
        getTextLocationAndCoord(jsonSave),
        jsonSave.text_date,
      ]
    } else {
      text = [
        jsonSave.text_coordinates_title,
        jsonSave.text_location,
        jsonSave.text_date,
        jsonSave.text_title
      ]
    }

    text = text.filter(Boolean).reverse().join("\n")

    canvasDetails.add(textDetails)
    canvasDetails.centerObject(textDetails)
    canvasDetails.renderAll()

    textLayerSplit.push({
      base64: getTextLayerBase64(elementDetails),
      x: getTextLeft(textDetails.width, resolution.width, originalSpec.text_details.x_modifier, originalSpec.text_details.text_align) - (canvasWidth / 2),
      y: getTextTop(textDetails.height, resolution.height, text, originalSpec.text_details.y_modifier, originalSpec.text_details.max_text_lines, originalSpec.text_details.vertical_align, originalSpec.text_details.line_height_modifier) - (canvasHeight / 2)
    })
  }

  return textLayerSplit;
}

const prepareText = (jsonSaveEditor) => {
  const jsonSave = {...jsonSaveEditor}
  const allText = [
    'text_title',
    'text_messages',
    'text_date',
    'text_location',
    'text_coordinates_title',
    'text_city',
    'text_country'
  ]
  
  allText.forEach(t => {
    if (!window.nse_setting_avaliable.includes(t)) {
      jsonSave[t] = ''
    }
  })

  return jsonSave
}


